import { v4 as uuid } from 'uuid';

import { Interceptor, InterceptorRequestConfig } from '../http.service';

export function markRequestRequestInterceptor(): Interceptor {
    return {
        request: (config: InterceptorRequestConfig) => {
            if (config.headers) {
                (config.headers as Record<string, unknown>)['X-Request-Id'] = uuid();
            }
        }
    };
}
